import React, { useRef, useEffect } from "react";
import "../modal/ModalPanel.scss";

export default function Draggable(props) {
  const mydivRef = useRef();
  const headerRef = props.headerRef || null;
  const div = {
    position: "absolute",
    zIndex: 110,
    backgroundColor: "#f1f1f1",
    textAlign: "center",
    border: "1px solid #d3d3d3",
    top: props?.position?.top ? props?.position?.top :"50%",
    left: props?.position?.left ? props?.position?.left :"50%",
    transform: "translate(-50%, -50%)",
    visibility: props.visibility,
  };

  useEffect(() => {
    if (mydivRef) {
      dragElement(mydivRef);
    }
  }, [mydivRef]);

  const dragElement = (elmnt) => {
    var pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;
    if (headerRef) {
      /* if present, the header is where you move the DIV from:*/
      headerRef.current.onmousedown = dragMouseDown;
    } else {
      /* otherwise, move the DIV from anywhere inside the DIV:*/
      elmnt.current.onmousedown = dragMouseDown;
    }

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      elmnt.current.style.top = elmnt.current.offsetTop - pos2 + "px";
      elmnt.current.style.left = elmnt.current.offsetLeft - pos1 + "px";
    }

    function closeDragElement() {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    }
  };
  return (
    <div id="mydiv" ref={mydivRef} style={div}>
      {props.children}
    </div>
  );
}
